module.exports = __webpack_public_path__ + "public/SiteIcons/verifiIconGreen.svg?a6988c5c";